import { Spin } from 'antd';

const LoadingComponent = () => {
  return <Spin className="mx-auto block h-full py-[30vh]" />;
};

export default LoadingComponent;
